module.exports = __webpack_public_path__ + "images/vanmossel_small6526f3b6347f3a35f7d72f598adb1213.png";